import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, PLATFORM_ID, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../core/services/auth.service';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { IntlService } from '../../core/services/intl.service';

declare var google: any;
declare var gapi: any;

@Component({
  selector: 'app-google-auth',
  templateUrl: './google-auth.component.html',
  styleUrls: ['./google-auth.component.scss'],
})
export class GoogleAuthComponent implements OnInit, OnDestroy {
  @ViewChild('googleSignContainer', { static: true }) googleSignContainer: any;

  @Input() showPrompt = false;
  @Input() showBotton = false;
  @Input() type = 'login'; // OR signup

  @Output('socialError') socialError = new EventEmitter();

  public auth2: any;
  public loading = false;

  public timeout1: any;
  public timeout2: any;
  public timeout3: any;

  constructor(private authService: AuthService, private router: Router, private intlService: IntlService, @Inject(PLATFORM_ID) protected platformId,
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId) && this.showPrompt) {
      if ( typeof google !== 'undefined') {
        this.setUpPrompt();
      } else {
        this.timeout1 = setTimeout(() => {
          this.setUpPrompt();
        }, 3 * 1000);
      }
    }

    if (isPlatformBrowser(this.platformId) && this.showBotton) {
      if (typeof gapi !== 'undefined') {
        this.setUpLegacyButton();
      } else {
        this.timeout2 = setTimeout(() => {
          this.setUpLegacyButton();
        }, 3 * 1000);
      }
    }
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId) && google?.accounts) {
      google.accounts.id.cancel();
    }
    clearTimeout(this.timeout1);
    clearTimeout(this.timeout2);
    clearTimeout(this.timeout3);
  }

  setUpPrompt() {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }
    google?.accounts?.id?.initialize({
      client_id: environment.googleApp.clientId,
      ux_mode: 'popup',
      response_type: 'token',
      prompt_parent_id: 'prompt-parent',
      locale: this.intlService.getCurrentLanguage(),
      enable_granular_consent: true,
      callback: (response) => this.handleCredentialResponse(response),
    });

    this.timeout3 = setTimeout(() => {
      google?.accounts?.id?.prompt((notification) => {
        if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
          // todo: show button?
        }
      });
    }, 3 * 1000);
  }

  setUpLegacyButton() {
    const self = this;
    gapi.load('auth2', function () {
      self.auth2 = gapi.auth2.init({
        client_id: environment.googleApp.clientId,
        cookiepolicy: 'single_host_origin',
        scope: 'profile email',
        enable_granular_consent: true,
      });
      self.attachLegacySignin(document.getElementById('googleBtn'));
    });
  }

  attachLegacySignin(element) {
    const self = this;
    this.auth2.attachClickHandler(element, {}, (response) => this.doLegacyAuth(response));
  }

  doLegacyAuth(googleUser) {
    this.handleCredentialResponse(googleUser.getAuthResponse().access_token, 'google');
  }

  handleCredentialResponse(response, method = 'google-one-tap') {
    this.authService.googleAuth(response.credential || response, method).subscribe(
      (res) => {
        this.router.navigateByUrl('/dashboard');
      },
      (err) => {
        this.handleError(err);
      }
    );
  }

  handleError(error?) {
    this.socialError.emit(true);
    this.loading = false;
  }

}
